<template>
  <div class="bg-white">
    <div class="layout-wrapper">
      <!--      <header-bar/>-->
      <div v-if="!app.switchCRM" class="d-lg-flex">
        <ExpiredBanner v-if="showExpiredBanner" />
        <TermAcceptPopup v-if="showTermAccept" />
        <nav-menu v-if="!app.loginV2" />
        <router-view v-if="renderComponent && app.verified" />
        <!--        <router-view />-->
        <ShopExpiresPopup v-if="accountExpireds.length>0 " :accounts="accountExpireds" />
        <!--        <SuggestTagPopup v-if="suggestTag" />-->
        <!--        <AccountPaymentPopup v-if="app.zaloNotify" />-->
<!--               <CloudBanner v-if="this.showCloudBanner && renderComponent" />-->
               <!-- <BannerFlex  v-if="renderComponent" bannerLink="banner_banking.svg" />
               <new-banner v-if="this.showNewBanner && renderComponent" /> -->
      </div>
      <div v-if="app.switchCRM">
        <h2 style="height: 100vh !important;" class="text-danger d-flex justify-content-center " v-if="errorCRM">
          Bạn không có quyền truy cập SaleworkZalo!
        </h2>
        <div v-else>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
import Config from "./lib/Config";
import ShopExpiresPopup from "./components/ShopExpiresPopup";
import ExpiredBanner from "./components/ExpiredBanner";
import TermAcceptPopup from "./components/Popup/TermAcceptPopup";
// import CloudBanner from "@/components/Popup/CloudBanner";
// import BannerFlex from "@/components/Popup/BannerFlex";
// import NewBanner from "@/components/Popup/NewBanner";
// import AccountPaymentPopup from "./components/AccoxuntPaymentPopup";

export default {
  name: "App",
  data() {
    return {
      errorCRM: false,
      accountExpireds: [],
      renderComponent: true,
      userPlan: "",
      showPopDeleteShop: false,
      suggestTag: false,
      zaloNotify: false,
      showExpiredBanner: false,
      showTermAccept: false,
      showTour: true,
      showCloudBanner: true,
      showNewBanner: false
    };
  },
  components: {
    // NewBanner,
    // CloudBanner,
    TermAcceptPopup,
    ExpiredBanner,
    // AccountPaymentPopup,
    ShopExpiresPopup,
    // BannerFlex,
    NavMenu: () => import("./components/NavMenu")
    // HeaderBar: () => import("./components/Header")
  },

  methods: {
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    verifyToken() {
      let config = {};
      if (Config.DEV) {
        config = {
          headers: {
            "evn-token": "aEdib2EzeDkzdyUyRjRLREdFUnQzbGtnJTNEJTNEOlJIM2FkOW1NZXJoWWFIOU1IRWg3S3clM0QlM0Q"
          }
        };
      }

      this.$http
        .get("/api/auth/verify", config)
        .then(response => {
          this.fetchDataLocal(response);
        })
        .catch(() => {
          if (this.app.switchCRM) {
            this.errorCRM = true;
            return;
          }
          window.location = "https://salework.net/login?target=zalo";
        });
    },
    fetchAllAccounts() {
      return this.$http.get("/api/account/getAll").then(resp => {
        return this.accounts = resp.data;
      });
    },
    fetchCustomerCode() {
      return this.$http.get("/api/v2/customer/getCode").then(resp => {
        this.app.customerCodeList = resp.data;
      });
    },
    fetchDataLocal(response) {
      this.verified = true;
      this.app.shopExpired = false;
      this.app.restDay = 0;
      let data = response.data;
      this.app.paymentType = data.paymentType;
      this.checkShopExpired();

      // if (!localStorage.getItem("showTour")) {
      this.showTour = false;
      // }
      if (data.accessToken != null) {
        localStorage.setItem("userToken", data.accessToken);
        localStorage.setItem("loginV2Token", data.loginV2Token);
        localStorage.setItem("cToken", data.ctoken);

        this.app.user = data.user;
        this.app.sessionId = data.sessionId;
        if (data.user.termAccept == 0 || data.user.termAccept == -1) {
          this.showTermAccept = true;
        } else if (!this.app.shopExpired) {
          this.app.permissions = JSON.parse(data.permissions);
          this.app.shopLimit = data.shopLimit;
          this.app.staffLimit = data.staffLimit;
          this.app.verified = true;
          this.userPlan = data.user.plan;
          this.app.showAllContact = data.showAllContact;
          this.app.showPhoneInContact = data.showPhoneInContact;
          this.app.showListFriend = data.showListFriend;

          if (!this.isUserTypeAdmin()) {
            if (data.tagAssignMe != null) {
              this.app.tagAssignMe = JSON.parse(data.tagAssignMe);
            }
            if (data.tagAssign != null) {
              this.app.tagAssign = JSON.parse(data.tagAssign);
            }
          }
          if (!localStorage.getItem("CloudBanner")) {
            if (this.isUserTypeAdmin()) {
              this.showCloudBanner = true;
            }
          }
          if (!localStorage.getItem("banner14052024")) {
            this.showNewBanner = true;
          }
          this.fetchAllQuickReply();
          this.forceRerender();
          this.fetchAllAccounts().then(accounts => {
            this.app.accounts = accounts.filter(s => s.status === "ACTIVE");
            this.accountExpireds = accounts.filter(s => s.status === "OFF");
          });
          this.fetchAccountList();
          this.getAllGroupId();
          this.getAllCharacterFilter();
          this.getAccountSetting();
          this.getDraftMessage();
          this.fetchCustomerCode();
          this.getAlias();
        }
      } else {
        this.showExpiredBanner = true;
      }
    }

  },
  created() {
    if (window.location.pathname == "/loginZaloV2") {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.app.cToken = urlParams.get("cToken");
      this.app.loginV2 = true;
      this.app.verified = true;
    } else {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const conversationId = urlParams.get("id");
      if (conversationId) {
        this.app.switchCRM = true;
        this.app.conversationIdForCRM = conversationId;
      }

      if (!this.app.verified) {

        this.verifyToken();
      }
    }
  }
};
</script>

<style>
@import "style/css/magnific-popup.css";
@import "style/css/owl.carousel.min.css";
@import "style/css/owl.theme.default.min.css";
@import "style/css/bootstrap-dark.min.css";
@import "style/css/bootstrap.min.css";
@import "style/css/app-dark.min.css";
@import "style/css/app.min.css";
@import "style/scss/icon.css";
</style>
